import { TimelineMax, Power3 } from 'gsap';

const ShowcaseIn = (element) => {
  const tl = new TimelineMax({ paused: true });
  tl.to(element, 1, { y: 0, autoAlpha: 1, ease: Power3.easeOut });
  return tl;
};

export default ShowcaseIn;
